import React, { Component } from 'react';
import { connect } from 'react-redux';

import Form from '../form';
import * as templateHelper from './templateHelper';

import get from 'lodash.get';
import { bindActionCreators } from 'redux';
import * as handlers from '../../modules/autocomplete';
import OptionalLabel from '../common/optionalLabel';

class ManagedSearch extends Component {
  onValueChange = (event, obj) => {
    if (!this.props.onChange) {
      return;
    }
    const value = typeof obj.value === 'string' ? obj.value.trim() : obj.value;
    const item = get(this.props.data, 'list', []).find(
      (x) => x.email === value
    );
    this.props.onChange(this.props.path, value, item ? { item } : undefined);
  };

  search = (event, { searchQuery }) => {
    if (!this.props.request) {
      return;
    }
    let request = this.props.request();
    request.text = searchQuery;

    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      this.props.searchEntities(
        this.props.searchEntity,
        this.props.path,
        request
      );
    }, 500);
  };

  render() {
    const label =
      this.props.validation && this.props.validation.required === false ? (
        <OptionalLabel>{this.props.label}</OptionalLabel>
      ) : (
        this.props.label
      );
    return (
      <Form.Autocomplete
        id={this.props.id}
        allowFreeText
        label={label}
        subtext={this.props.subtext}
        value={this.props.value || ''}
        onChange={this.onValueChange}
        search={this.search}
        options={getOptions(this.props.data)}
        loading={this.props.loading}
        validation={this.props.validation}
      />
    );
  }
}

const getOptions = (data) =>
  get(data, 'list', []).map((x) => ({
    text: x.email,
    subtext: `${x.firstName} ${x.lastName}`,
    value: x.email
  }));

const mapState = (state, ownProps) => {
  // Get the label and subtext from data store.
  const label = templateHelper.getTranslation(ownProps.label);
  const subtext = templateHelper.getTranslation(ownProps.subtext);
  const inputLabel = templateHelper.getTranslation(ownProps.inputLabel);

  const path = ownProps.path;
  const searchEntity = ownProps.entity;

  const loading = get(state, `autocomplete.${path}.loading`);
  const data = get(state, `autocomplete.${path}.data`);
  const value = templateHelper.getValue(state.templateBuilderEx, path);

  return {
    label,
    subtext,
    inputLabel,
    data,
    loading,
    path,
    searchEntity,
    value
  };
};

const mapDispatch = (dispatch) => {
  return bindActionCreators(handlers, dispatch);
};

export const TemplateSearch = connect(mapState, mapDispatch)(ManagedSearch);
